export const sabaParlayHandler = {
  methods: {
    handlePublicParlayDialog(row) {
      if (row.dialog_type == "detail") {
        let data = {
          trans_id: row.trans_id,
          source_type: row.source_type,
          bet_type:row.bet_type
        };
        this.$refs.sabaParlayMatchs.showDialogForPublic(data);
      } else {
        let data = {
          trans_id: row.trans_id,
          betId: row.bet_id,
          content_type: row.content_type,
          createtime: row.createtime,
          source_type: row.source_type,
          bet_type:row.bet_type
        };
        this.$refs.sabaParlayResult.showDialogForPublic(data);
      }
    },
  }
}